import { DownloadOutlined } from "@ant-design/icons";
import { Chip, InputLabel, Stack, Typography } from "@mui/material";
import { FileDto } from "interfaces/common";
import { convertImageSourceToFile, downloadFile } from "utils/file";
import {isEmpty} from "lodash";

interface Props {
    attachments: FileDto[];
}

export default function ReportAttachments({ attachments }: Props) {
    const downloadAllAttachments = async (attachments: FileDto[]) => {
        const files = await Promise.all(
            attachments.map((attachment) =>
                convertImageSourceToFile(
                    `${process.env.REACT_APP_BASE_URL}/${attachment.path}`,
                    attachment.originalName
                )
            )
        );

        files.forEach((file) => {
            downloadFile(file);
        });
    };

    return (
        <Stack spacing={1}>
            {
                !isEmpty(attachments) && <>
                    <InputLabel>
                        <Typography fontWeight={700}>Attachments:</Typography>
                    </InputLabel>
                    <Stack direction="row" spacing={1}>
                        {attachments.map((attachment, idx) => (
                            <Chip onClick={() => downloadAllAttachments([attachment])} key={idx} label={attachment.originalName} variant="outlined" />
                        ))}
                    </Stack>
                    <Typography
                        color="green"
                        fontWeight="bold"
                        style={{
                            cursor: "pointer",
                        }}
                        onClick={() => downloadAllAttachments(attachments)}
                    >
                        <DownloadOutlined />
                        &nbsp; Download all
                    </Typography>
                </>
            }
        </Stack>
    );
}
